/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Iceutility } from '../../../services/iceutility';
import { ReportService } from '../../../services/report/report.service';
import { ScheduleService } from '../../../services/schedule/schedule.service';
import { IceTypes } from '../../icetypes';
import { appointment } from '../../schedule/appointment';
import { appointmentstat } from '../../stats/appointmentstat';
import { patientstat } from '../../stats/patientstat';
import { report, reportDataField, ReportDataTypes, ReportKeyTypes } from '../report';
import { reportdata } from '../reportdata';
import { reporttemplate } from '../reporttemplate';
import { reportfilter } from '../subs/reportfilter';
import { basereportprocess } from './basereportprocess';

export class schedulereport extends basereportprocess {

  appointment_fields: string[] = [];
  mapAppointmentUserNames: any = {};
  mapAppointmentColumnNames: any = {};

  szUSER_APPOINTMENT_KEY: string = "Appointment Key";
  szUSER_APPOINTMENT_TYPE: string = "Appointment Type";
  szUSER_STAFF: string = "Organizer";
  szUSER_LOCATION: string = "Location";
  szUSER_STATUS: string = "Status";
  szUSER_STATUS_NOTE: string = "Status Note";
  szUSER_DATE: string = "Date";
  szUSER_START_TIME: string = "Start Time";
  szUSER_END_TIME: string = "End Time";
  szUSER_OTHER_LABEL_INFO: string = "Other Label Info.";
  szUSER_MINUTES: string = "Minutes";
  szUSER_REASON_FOR_VISIT: string = "Reason(s) for Visit";
  szUSER_PATIENT_NAME: string = "Patient Name";
  szUSER_PATIENT_ADDRESS: string = "Patient Address";
  szUSER_PATIENT_CITY: string = "Patient City";
  szUSER_PATIENT_STATE_ID: string = "Patient State";
  szUSER_PATIENT_POSTAL_CODE: string = "Patient Postal Code";
  szUSER_PATIENT_AGE: string = "Patient Age";
  szUSER_PATIENT_DOB: string = "Patient Date of Birth";
  szUSER_PATIENT_CHART_NO: string = "Patient Chart No.";
  szUSER_PATIENT_SEX: string = "Patient Sex";
  szUSER_PATIENT_HOME_PHONE: string = "Patient Contact 1";
  szUSER_PATIENT_WORK_PHONE: string = "Patient Contact 2";

  szTC_APPOINTMENT_KEY: string = "APPOINTMENT_KEY";
  szTC_APPOINTMENT_TYPE: string = "APPOINTMENT_TYPE";
  szTC_STAFF: string = "ORGANIZER";
  szTC_LOCATION: string = "LOCATION";
  szTC_STATUS: string = "APPOINTMENT_STATUS";
  szTC_STATUS_NOTE: string = "APPOINTMENT_STATUS_NOTE";
  szTC_DATE: string = "DATE";
  szTC_START_TIME: string = "TIME_SLOT_START";
  szTC_END_TIME: string = "TIME_SLOT_END";
  szTC_OTHER_LABEL_INFO: string = "SUBJECT";
  szTC_MINUTES: string = "MINUTES";
  szTC_REASON_FOR_VISIT: string = "REASON_FOR_VISIT";
  szTC_PATIENT_NAME: string = "PATIENT_NAME";
  szTC_PATIENT_ADDRESS: string = "PATIENT_ADDRESS";
  szTC_PATIENT_CITY: string = "PATIENT_CITY";
  szTC_PATIENT_STATE_ID: string = "PATIENT_STATE";
  szTC_PATIENT_POSTAL_CODE: string = "PATIENT_POSTAL_CODE";
  szTC_PATIENT_AGE: string = "PATIENT_AGE";
  szTC_PATIENT_DOB: string = "PATIENT_DOB";
  szTC_PATIENT_CHART_NO: string = "PATIENT_TRANS_ACCOUNT";
  szTC_PATIENT_SEX: string = "PATIENT_SEX";
  szTC_PATIENT_HOME_PHONE: string = "COMMUNICATION_NUMBER1";
  szTC_PATIENT_WORK_PHONE: string = "COMMUNICATION_NUMBER2";

  constructor(repSvc: ReportService, parentRpt: report, templates: report[], curTemplateReference: reporttemplate, data: reportdata) {
    super(repSvc, parentRpt, templates, curTemplateReference, data);

    let appt = new appointment();
    let sTableName = appt.gettablename();
    this.addSelectionTable(sTableName);

    sTableName += "." + this.szTC_APPOINTMENT_KEY;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szTC_APPOINTMENT_KEY] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_APPOINTMENT_KEY;

    sTableName = appt.gettablename() + "." + this.szTC_APPOINTMENT_TYPE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_APPOINTMENT_TYPE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_APPOINTMENT_TYPE;

    sTableName = appt.gettablename() + "." + this.szTC_STAFF;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_STAFF] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_STAFF;

    sTableName = appt.gettablename() + "." + this.szTC_LOCATION;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_LOCATION] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_LOCATION;

    sTableName = appt.gettablename() + "." + this.szTC_STATUS;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_STATUS] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_STATUS;

    sTableName = appt.gettablename() + "." + this.szTC_STATUS_NOTE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_STATUS_NOTE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_STATUS_NOTE;

    sTableName = appt.gettablename() + "." + this.szTC_DATE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_DATE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_DATE;

    sTableName = appt.gettablename() + "." + this.szTC_START_TIME;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_START_TIME] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_START_TIME;

    sTableName = appt.gettablename() + "." + this.szTC_END_TIME;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_END_TIME] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_END_TIME;

    sTableName = appt.gettablename() + "." + this.szTC_OTHER_LABEL_INFO;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_OTHER_LABEL_INFO] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_OTHER_LABEL_INFO;

    sTableName = appt.gettablename() + "." + this.szTC_MINUTES;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_MINUTES] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_MINUTES;

    sTableName = appt.gettablename() + "." + this.szTC_REASON_FOR_VISIT;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_REASON_FOR_VISIT] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_REASON_FOR_VISIT;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_NAME;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_NAME] = sTableName;
    this.mapAppointmentColumnNames[sTableName] =  this.szUSER_PATIENT_NAME;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_ADDRESS;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_ADDRESS] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_ADDRESS;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_CITY;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_CITY] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_CITY;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_STATE_ID;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_STATE_ID] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_STATE_ID;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_POSTAL_CODE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_POSTAL_CODE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_POSTAL_CODE;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_AGE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_AGE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_AGE;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_DOB;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_DOB] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_DOB;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_CHART_NO;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_CHART_NO] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_CHART_NO;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_SEX;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_SEX] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_SEX;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_HOME_PHONE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_HOME_PHONE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_HOME_PHONE;

    sTableName = appt.gettablename() + "." + this.szTC_PATIENT_WORK_PHONE;
    this.appointment_fields.push(sTableName);
    this.mapAppointmentUserNames[this.szUSER_PATIENT_WORK_PHONE] = sTableName;
    this.mapAppointmentColumnNames[sTableName] = this.szUSER_PATIENT_WORK_PHONE;
  }

  // all fields to select from
  onGetSelectionField(fieldIndex: number): reportDataField {
    if (fieldIndex >= 0 && fieldIndex < this.appointment_fields.length) {
      let sFullName = this.appointment_fields[fieldIndex];
      let field = new reportDataField([]);
      field.setTableName(reportDataField.parseTableName(sFullName));
      field.setColumnName(reportDataField.parseColumnName(sFullName));

      let sUserName = this.mapAppointmentColumnNames[sFullName];
      if (Iceutility.isStringUndefinedNullOrEmpty(sUserName)) {
        return null;
      }
      field.setDisplayName(sUserName);

      let sColumnName = field.getColumnName();
      if (sColumnName.toUpperCase() == this.szTC_APPOINTMENT_KEY)
        field.setDataType(ReportDataTypes.dtText);
      else if (sColumnName.toUpperCase() == this.szTC_APPOINTMENT_TYPE)
        field.setDataType(ReportDataTypes.dtText);
      else if (sColumnName.toUpperCase() == this.szTC_START_TIME
        || sColumnName.toUpperCase() == this.szTC_END_TIME) {
        field.setDataType(ReportDataTypes.dtDateTime);
      }
      else
        field.setDataType(ReportDataTypes.dtText);

      if (sColumnName.toUpperCase() == this.szTC_APPOINTMENT_KEY)
        field.setKeyType(ReportKeyTypes.ktPrimary);

      return field;
    }

    return null;
  }

  onGetSelectionFieldName(displayName: string): string {
    let cname = this.mapAppointmentUserNames[displayName];
    if (Iceutility.isStringUndefinedNullOrEmpty(cname)) {
      return "";
    }
    return cname;
  }

  // performs the database query
  onQueryRecord(fields: string[], filters: reportfilter[], preview: boolean = false): Array<Array<any>>  {
    let ret: Array<Array<any>> = [];

    let repData = this.getReportData();
    if (repData == null || repData.PATIENTSTATS.length == 0) return null

    for (let iptStat = 0; iptStat < repData.PATIENTSTATS.length; iptStat++) {
      let ptStat = repData.PATIENTSTATS[iptStat];
      if (ptStat == null) continue;

      for (let iappt = 0; iappt < ptStat.APPTSTATS.length; iappt++) {
        let rec = this.getDataSchedule(repData, ptStat, ptStat.APPTSTATS[iappt], fields);
        if (rec != null)
          ret.push(rec);
      }
    }
    return ret;
  }

  getDataSchedule(repData: reportdata, ptstat: patientstat, appt: appointmentstat, cols: string[]): any[] {
    let record: any[] = [];
    if (repData == null) return null;
    if (ptstat == null || appt == null) return null;
    if (cols == null || cols.length == 0) return null;

    for (let icol = 0; icol < cols.length; icol++) {
      switch (cols[icol]) {
        case "APPOINTMENT.ORGANIZER":
          let parts = appt.provider_keywords != null ? appt.provider_keywords.split(",") : [];
          if (parts.length > 0) {
            // only show the first one
            let foundOrg = repData.PROVIDERSTATS.filter(p => p.trans_account == parts[0]);
            if (foundOrg.length > 0) {
              record[icol] = foundOrg[0].getdisplayname(false);
            }
            else {
              record[icol] = "";
            }
          }
          break;
        case "APPOINTMENT.LOCATION":
          let foundLocation = repData.PROVIDERSTATS.filter(p => p.trans_account == appt.trans_account);
          if (foundLocation.length > 0) {
            record[icol] = foundLocation[0].getdisplayname(Iceutility.toLong(foundLocation[0].account_type) == IceTypes.ACCOUNT_TYPE.actFacility);
          }
          else {
            record[icol] = "";
          }
          break;
        case "APPOINTMENT.PATIENT_TRANS_ACCOUNT":
          record[icol] = ptstat.trans_account;
          break;
        case "APPOINTMENT.PATIENT_NAME":
          record[icol] = ptstat.getdisplayname();
          break;
        case "APPOINTMENT.PATIENT_ADDRESS":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_CITY":
          record[icol] = ptstat.city;
          break;
        case "APPOINTMENT.PATIENT_STATE":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_POSTAL_CODE":
          record[icol] = ptstat.postal_code;
          break;
        case "APPOINTMENT.PATIENT_AGE":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_DOB":
          let dobColName = reportDataField.parseColumnName(cols[icol]);
          let dob = ptstat[dobColName.toLocaleLowerCase()];
          if (cols[icol] == "PATIENT_STAT.DOB")
            record[icol] = Iceutility.isTextDateTime(dob) ? Iceutility.getDateTextEx(dob, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dob), null, false);
          else {
            record[icol] = "";
          }
          break;
        case "APPOINTMENT.PATIENT_SEX":
          record[icol] = ptstat.sex;
          break;
        case "APPOINTMENT.COMMUNICATION_NUMBER1":
          record[icol] = ptstat.communication_number1;
          break;
        case "APPOINTMENT.COMMUNICATION_NUMBER2":
          record[icol] = ptstat.communication_number2;
          break;
        case "APPOINTMENT.APPOINTMENT_KEY":
        case "APPOINTMENT.APPOINTMENT_TYPE":
        case "APPOINTMENT.APPOINTMENT_STATUS":
        case "APPOINTMENT.TIME_SLOT_START":
        case "APPOINTMENT.TIME_SLOT_END":
        case "APPOINTMENT.SUBJECT": {
          let colName = reportDataField.parseColumnName(cols[icol]);
          let data = appt[colName.toLocaleLowerCase()];
          if (cols[icol] == "APPOINTMENT.TIME_SLOT_START" || cols[icol] == "APPOINTMENT.TIME_SLOT_END")
            data = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data));
          else if (cols[icol] == "APPOINTMENT.APPOINTMENT_STATUS")
            data = ScheduleService.getApptStat(data);
          else if (cols[icol] == "APPOINTMENT.APPOINTMENT_TYPE")
            data = ScheduleService.getAppointmentType(data);

          record[icol] = data;
          break;
        }
        case "APPOINTMENT.DATE":
          record[icol] = Iceutility.getDateTextEx(Iceutility.GetLocalDate());
          break;
        case "APPOINTMENT.APPOINTMENT_STATUS_NOTE":
          record[icol] = "";
          break;
        case "APPOINTMENT.MINUTES":
          let dtend = appt.time_slot_end;
          let dtstart = appt.time_slot_start;
          dtend = Iceutility.isTextDateTime(dtend) ? Iceutility.GetLocalDate(dtend) : Iceutility.ConvertFromDotNetServerTime(dtend);
          dtstart = Iceutility.isTextDateTime(dtstart) ? Iceutility.GetLocalDate(dtstart) : Iceutility.ConvertFromDotNetServerTime(dtstart);

          const milliseconds1 = dtstart.getTime(); // or +date1
          const milliseconds2 = dtend.getTime(); // or +date2
          const diffMilliseconds = Math.abs(milliseconds2 - milliseconds1);
          const diffMinutes = diffMilliseconds / 60000;
          record[icol] = diffMinutes.toString();
          break;
        case "APPOINTMENT.REASON_FOR_VISIT":
          record[icol] = "";
          break;
      }
    }
    return record;
  }

  ///////////////////////////////////////////////////////////////////////////
  // user commands
  onOpen(reportKey: string, reportName: string): boolean {
    return super.onOpen(reportKey, reportName);
  }
}
